<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>新宴席管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel :collapse="false">
      <template slot="header">搜索</template>
      <el-form :model="search"
               label-width="110px"
               size="medium"
               @submit.native.prevent="onSearch()">
        <div class="re-el-form__flex">
          <el-form-item label="宴席申报单号">
            <el-input v-model="search.order_code"
                      clearable
                      placeholder="请输入申报单号"></el-input>
          </el-form-item>
          <el-form-item label="任务ID">
            <el-input v-model="search.taskid"
                      clearable
                      placeholder="主平台任务ID"></el-input>
          </el-form-item>
          <el-form-item label="导入时间">
            <el-date-picker v-model="search.created_range"
                            class="width-max"
                            type="datetimerange"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            range-separator="至"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"
                            align="center"
                            clearable>
            </el-date-picker>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     native-type="submit">搜索</el-button>
          <el-button icon="el-icon-download"
                     @click="onExportSearch()">按搜索结果导出</el-button>
        </el-form-item>
      </el-form>
    </layout-panel>

    <layout-panel>
      <template slot="header">列表</template>
      <el-table :data="table"
                stripe
                border>
        <el-table-column prop="id"
                         label="ID"
                         width="80"></el-table-column>
        <el-table-column prop="order_code"
                         label="宴席申报单号"
                         min-width="160"></el-table-column>
        <el-table-column label="主平台任务"
                         width="120">
          <template slot-scope="scope">
            <router-link v-if="scope.row.taskid"
                         class="link-text"
                         :to="{path: '/task/table', query: {text: scope.row.taskid}}">
              {{ scope.row.taskid }}
            </router-link>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="created_at"
                         label="导入时间"
                         min-width="160"></el-table-column>
        <el-table-column prop="banquet_time"
                         label="宴席主宴时间"
                         min-width="160"></el-table-column>
        <el-table-column prop="banquet_type"
                         label="宴席类型"
                         min-width="100"></el-table-column>
        <el-table-column prop="product_name"
                         label="用酒品牌"
                         min-width="100"></el-table-column>
        <el-table-column prop="table_num"
                         label="桌数"
                         width="80"></el-table-column>
        <el-table-column prop="province_name"
                         label="省"
                         width="90"></el-table-column>
        <el-table-column prop="city_name"
                         label="市"
                         width="90"></el-table-column>
        <el-table-column prop="area_name"
                         label="区"
                         width="90"></el-table-column>
        <el-table-column prop="address"
                         label="详细地址"
                         min-width="180"></el-table-column>
        <el-table-column prop="longitude"
                         label="经度"
                         min-width="110"></el-table-column>
        <el-table-column prop="latitude"
                         label="纬度"
                         min-width="110"></el-table-column>
        <el-table-column label="签到窗口"
                         min-width="180">
          <template slot-scope="scope">
            {{ scope.row.checkin_start }} ~ {{ scope.row.checkin_end }}
          </template>
        </el-table-column>
        <el-table-column prop="task_end_time"
                         label="任务结束"
                         min-width="160"></el-table-column>
        <el-table-column label="操作"
                         width="130"
                         fixed="right">
          <template slot-scope="scope">
            <el-button type="text"
                       size="mini"
                       @click="$router.push({name: '宴席任务详情', params: {id: scope.row.id}})">查看</el-button>
            <el-button v-if="scope.row.marketid"
                       type="text"
                       size="mini"
                       @click="$router.push({name: '门店修改', params: {id: scope.row.marketid}})">修改门店</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>
  </div>
</template>

<script>
import table from '@core/mixins/table-v3'

export default {
  mixins: [table],
  data () {
    return {
      search: {
        order_code: '',
        taskid: '',
        created_range: [],
      },
      searchFieldType: {
        taskid: Number,
        current_page: Number,
        per_page: Number,
      },
      exportHeader: [
        {key: 'id', text: 'ID'},
        {key: 'order_code', text: '宴席申报单号'},
        {key: 'taskid', text: '主平台任务'},
        {key: 'created_at', text: '导入时间'},
        {key: 'banquet_time', text: '宴席主宴时间'},
        {key: 'banquet_type', text: '宴席类型'},
        {key: 'product_name', text: '用酒品牌'},
        {key: 'table_num', text: '桌数'},
        {key: 'province_name', text: '省'},
        {key: 'city_name', text: '市'},
        {key: 'area_name', text: '区'},
        {key: 'address', text: '详细地址'},
        {key: 'longitude', text: '经度'},
        {key: 'latitude', text: '纬度'},
        {key: 'checkin_start', text: '签到开始'},
        {key: 'checkin_end', text: '签到结束'},
        {key: 'task_end_time', text: '任务结束'},
      ],
    }
  },
  methods: {
    getTableData (params) {
      const query = Object.assign({}, params)
      const range = query.created_range
      if (range && range.length === 2) {
        query.created_at_begin = range[0]
        query.created_at_end = range[1]
      }
      delete query.created_range
      return request.page('banquetTaskQuery', query)
    },
    onExportSearch () {
      this.$export(this.$route.meta.title, {
        fileHeader: this.exportHeader,
        total: this.pagination.total,
        request: this.getTableData,
        requestParams: this.search,
      })
    },
  },
}
</script>

<style lang="scss"
       scoped>
.link-text {
  color: #409EFF;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/banquet-task/pages/BanquetTaskRecordTable.vue